import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { CookiesBanner } from "../assets/cookies";
import { CookiesBannerBtn } from "../assets/cookieBtn";
import { useCookieConsent } from "../hooks/cookies";

export const CookieBanner = () => {
  const { t, i18n } = useTranslation();
  const { acceptCookies, rejectCookies, hasConsented } = useCookieConsent();
  const language = i18n.language;

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (hasConsented) {
        setVisible(false);
      } else {
        setVisible(true);
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [hasConsented]);

  const handleAccept = () => {
    acceptCookies();
    setVisible(false);
  };

  const handleReject = () => {
    rejectCookies();
    setVisible(false);
  };

  if (!visible || hasConsented) return null;

  const subtitle = t("cookieBanner.subtitle").replace(
    "/privacy-policy#cookies",
    language === "de" ? "/privacy-policy/de#cookies" : "/privacy-policy#cookies"
  );

  return (
    <div className="fixed bottom-6 mx-[10px] md:right-6 z-50 animate-slide-up">
      <div className="inline-flex p-6 md:p-8 gap-6 bg-white rounded-[24px] shadow-lg w-full lg:max-w-[1200px] items-center">
        <div className="flex-shrink-0 hidden md:block">
          <CookiesBanner />
        </div>

        <div className="flex flex-col lg:flex-row flex-grow items-center relative justify-between gap-6">
          <div className="absolute top-[-20px] right-[-10px] p-1">
            <button onClick={() => setVisible(false)} aria-label="Close">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M0.916016 15L14.916 1"
                  stroke="#9893A3"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M14.916 15L0.916016 1"
                  stroke="#9893A3"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>

          <div className="flex flex-col w-[90%] justify-center md:text-pretty">
            <p className="text-[20px] font-600 text-primary-700 md:hidden mb-[16px]">
              {String(t("cookieBanner.mobile"))}
            </p>
            <p className="text-[16px] font-400 text-neutral-200 mb-3">
              {String(t("cookieBanner.title"))}
            </p>
            <p
              className="text-[16px] font-400 text-neutral-200"
              dangerouslySetInnerHTML={{
                __html: subtitle,
              }}
            />
          </div>

          <div className="flex gap-2 md:gap-5 flex-wrap md:flex-nowrap">
            <button
              onClick={handleAccept}
              className="p-[10px] md:px-[26px] md:py-[18px] rounded-full bg-primary-200 text-primary-400 text-[15px] font-600 flex gap-2 items-center w-max"
            >
              <CookiesBannerBtn />
              {String(t("cookieBanner.accept"))}
            </button>
            <button
              onClick={handleReject}
              className="p-[10px] md:px-[26px] md:py-[18px] rounded-full border border-neutral-300 text-[15px] font-600 text-[#170F49]"
              style={{ boxShadow: "0px 4px 8px 0px rgba(74, 58, 255, 0.08)" }}
            >
              {String(t("cookieBanner.reject"))}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
